export default "__VITE_ASSET__BloDHnko__"